import { Booking } from '../../core/models/booking';

export type HEALLO_STEP = 'WELCOME' | 'COLOR-PICK' | 'HEALLO-SESSION' | 'HEALLO-FINISH';

export interface HealloState {
  booking?: Booking;
  otherParticipantColor: string;
  currentParticipantColor: string;
  currentHealloStep: HEALLO_STEP;
  healloSession: {
    otherParticipantPressing?: boolean;
    currentParticipantPressing?: boolean;
    hasOtherParticipantArrivedToHeallo: boolean;
  };
  currentParticipantGradient: string[];
  otherParticipantGradient: string[];
  hasError: boolean;
}

export const initialHealloState = () =>
  ({
    otherParticipantColor: 'linear-gradient(to bottom, #4BD65C, #F7EC5E)',
    otherParticipantGradient: ['#4BD65C', '#F7EC5E'],
    currentParticipantGradient: ['#4BD65C', '#F7EC5E'],
    healloSession: {
      otherParticipantPressing: false,
      currentParticipantPressing: false,
      hasOtherParticipantArrivedToHeallo: false,
    },
    currentHealloStep: 'WELCOME',
    hasError: true,
  } as HealloState);
export interface HealloAction {
  type:
    | 'LOAD_BOOKING_SUCCESS'
    | 'LOAD_BOOKING_FAILURE'
    | 'SET_HEALLO_STEP'
    | 'SET_OTHER_PARTICIPANT_PRESSING'
    | 'SET_CURRENT_PARTICIPANT_PRESSING'
    | 'SET_CURRENT_PARTICIPANT_COLOR'
    | 'SET_OTHER_PARTICIPANT_COLOR';
  payload?: any;
}

const healloReducer = (state: HealloState = initialHealloState(), action: HealloAction): HealloState => {
  switch (action.type) {
    case 'LOAD_BOOKING_SUCCESS':
      return { ...state, booking: action.payload };
    case 'LOAD_BOOKING_FAILURE':
      return { ...state, hasError: true };
    case 'SET_OTHER_PARTICIPANT_PRESSING':
      return {
        ...state,
        healloSession: {
          otherParticipantPressing: action.payload,
          currentParticipantPressing: state.healloSession.currentParticipantPressing,
          hasOtherParticipantArrivedToHeallo: true,
        },
      };
    case 'SET_OTHER_PARTICIPANT_COLOR':
      return {
        ...state,
        otherParticipantColor: action.payload,
        otherParticipantGradient: extractGradientColor(action.payload, state.currentParticipantGradient),
        healloSession: {
          ...state.healloSession,
          hasOtherParticipantArrivedToHeallo: true,
        },
      };
    case 'SET_CURRENT_PARTICIPANT_PRESSING':
      return {
        ...state,
        healloSession: {
          ...state.healloSession,
          currentParticipantPressing: action.payload,
          otherParticipantPressing: state.healloSession.otherParticipantPressing,
        },
      };
    case 'SET_CURRENT_PARTICIPANT_COLOR':
      return {
        ...state,
        currentParticipantColor: action.payload,
        currentParticipantGradient: extractGradientColor(action.payload, state.currentParticipantGradient),
      };
    case 'SET_HEALLO_STEP':
      return { ...state, currentHealloStep: action.payload };
    default:
      return state;
  }
};

const extractGradientColor = (gradient: string, fallbackValue: string[]): string[] => {
  const colorRegex = /#[0-9A-Fa-f]{6}/g;
  const matches = gradient.match(colorRegex);

  return matches || fallbackValue;
};

export default healloReducer;
